import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/view/Dashboard'
import OrderPending from '@/components/view/OrderPending'
import OrderInfo from '@/components/view/OrderInfo'
import OrderCurrent from '@/components/view/OrderCurrent'
import Zone from '@/components/view/Zone'
import Zones from '@/components/view/Zones'
import TransferPending from '@/components/view/TransferPending'
import TransferCompleted from '@/components/view/TransferCompleted'
import Search from '@/components/view/Search'
import AddressBook from '@/components/view/AddressBook'
import PendingAccounts from '@/components/view/PendingAccounts'
import Logs from '@/components/view/Logs'
import Reports from '@/components/view/Reports'
import Settings from '@/components/view/Settings'
import WallFile from '@/components/view/WallFile'
import Drivers from '@/components/view/Drivers'
import Clients from '@/components/view/Clients'
import Login from '@/components/view/Login'
import Dev from '@/components/view/Dev'
import UsersVehiclesWrapper from '../components/view/UsersVehiclesWrapper.vue'
import InventoryPage from '../components/view/InventoryPage.vue'
import OrderDelivered from '@/components/view/OrderDelivered'
import ToVerify from '@/components/view/ToVerify.vue'
import Marketplace from '../components/view/Marketplace.vue'
import { db } from '../firebase'
import store from '../store/index'
import OrderToBill from '../components/view/OrderToBill.vue'
import OrderWaiting from '../components/view/OrderWaiting.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/OrderCurrent'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      }
    },
    {
      path: '/Orderpending',
      name: 'OrderPending',
      component: OrderPending,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/OrderInfo',
      name: 'OrderInfo',
      component: OrderInfo,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      },
      props: (route) => ({ query: route.query.orderId })
    },
    {
      path: '/OrderCurrent',
      name: 'OrderCurrent',
      component: OrderCurrent,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/OrderDelivered',
      name: 'OrderDelivered',
      component: OrderDelivered,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/ToBill',
      name: 'ToBill',
      component: OrderToBill,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      },
      props: (route) => ({ query: route.query.orderId })
    },
    {
      path: '/Waiting',
      name: 'Waiting',
      component: OrderWaiting,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      },
      props: (route) => ({ query: route.query.orderId })
    },
    {
      path: '/verify',
      name: 'Verify',
      component: ToVerify,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/Zone',
      name: 'Zone',
      component: Zone,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/TransferPending',
      name: 'TransferPending',
      component: TransferPending,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      }
    },
    {
      path: '/TransferCurrent',
      name: 'TransferCurrent',
      component: TransferCompleted,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/PendingAccounts',
      name: 'PendingAccounts',
      component: PendingAccounts,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/AddressBook',
      name: 'AddressBook',
      component: AddressBook,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/Users',
      name: 'Users/Vehicles',
      component: UsersVehiclesWrapper,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/Inventory',
      name: 'Inventory',
      component: InventoryPage,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/Settings',
      name: 'Settings',
      component: Settings,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      }
    },
    {
      path: '/Zones',
      name: 'Zones',
      component: Zones,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/WallFile',
      name: 'WallFile',
      component: WallFile,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/Drivers',
      name: 'Drivers',
      component: Drivers,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/Clients',
      name: 'Clients',
      component: Clients,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      },
      props: (route) => ({ query: route.query.code })
    },
    {
      path: '/Logs',
      name: 'Logs',
      component: Logs,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/Reports',
      name: 'Reports',
      component: Reports,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/Dev',
      name: 'Dev',
      component: Dev,
      meta: {
        requiresAuth: true,
        allowedRoles: ['full']
      }
    },
    {
      path: '/Marketplace',
      name: 'Marketplace',
      component: Marketplace,
      meta: {
        requiresAuth: true,
        allowedRoles: ['marketplace', 'full']
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // console.log('>>> to', to)
    // console.log('>>> from', from)
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = !!store.state.authorization
  let userRole = store.state.userInfo ? store.state.userInfo.userType : ''
  if (isAuthenticated && to.path !== '/login') {
    if (!userRole) {
      store.state.userInfo.userType = 'marketplace'
      userRole = 'marketplace'
      try {
        db.ref('users/transporters')
          .child(store.state.authorization.company)
          .child('userType')
          .set('marketplace')
      } catch (error) {
        console.error('Error updating user type:', error)
      }
    }
  }
  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (requiresAuth && isAuthenticated) {
    const allowedRoles = to.meta.allowedRoles
    if (allowedRoles && !allowedRoles.includes(userRole)) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
